export default {
  methods: {
    async handleLogout() {
      const h = this.$createElement
      const titleVNode = h('div', {
        domProps: { innerHTML: `<h1 class="p-4">Biztos, hogy szeretne kijelentkezni?</h1>` }
      })

      await this.$bvModal
        .msgBoxConfirm([titleVNode], {
          title: '',
          size: 'lg',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'Igen',
          cancelTitle: 'Nem',
          footerClass: 'p-2',
          centered: true,
          id: 'confirm-logout-modal'
        })
        .then(async value => {
          if (value == true) {
            await this.$store.dispatch('logout')
            this.$router.push('/')
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    }
  }
}
